// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1974":"summaryUserCache.worker","8335":"summarySlotCache.worker"}[chunkId] + "-" + {"1974":"9406fce990d2e0c8eb88","8335":"191192ed822a0ab60918"}[chunkId] + ".js";
};